export default {
  methods: {
    goToAppLogin() {
      window.location = this.AppLoginURL;
    },
    // goToAppRegister() {//DEPRECATED FUN
    //   window.location = this.AppRegisterURL;
    // },
    goToApplicantRegister() {
      window.location.href = `${this.AppURL}/registro/solicitante`;
    },
    goToInvestorRegister() {//inversionista
      window.location.href = `${this.AppURL}/registro/inversionista`;
    },
    goToInvestorProjectDetail(projectId) {//inversionista
      window.location.href = `${this.AppURL}/inversionista/oportunidad/${projectId}`;
    },
    goToSupplierRegister() {//instalador
      window.location.href = `${this.AppURL}/registro/instalador`;
    },
    goToSimulators() {
      window.location.href = `${this.AppURL}/quiero-un-credito`;
    },
    goToSimulatorEficienciaEnergetica() {
      window.location.href = `${this.AppURL}/quiero-un-credito/eficiencia-energetica`;
    },
    goToSimulatorMinadoDeBitcoin() {
      window.location.href = `${this.AppURL}/quiero-un-credito/minado-verde`;
    },
    openNewTabWithUrl(url){
      window.open(url, "_blank");
    },
    checkIfImageExists(url) {
      const img = new Image();
      img.src = url;
      var response = false;
      if (img.complete) {
        response = true;
      }else{
        img.onload = () => {
          response = true;
        };        
        img.onerror = () => {
          response = false;
        };
      }
      return response;
    },
  }
}